import React, { useEffect, useState } from 'react';

const C = {
  bg:     '#0d1117',
  card:   '#161b22',
  border: '#21262d',
  text:   '#e6edf3',
  muted:  '#8b949e',
  roed:   '#f87171',
};

export default function KlientPipelineFunnelSR() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [fejl, setFejl]       = useState(null);

  useEffect(() => {
    fetch('/api/os/strategisk/klient-pipeline', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.fejl) setFejl(d.fejl); else setData(d); })
      .catch(e => setFejl(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: 32, color: C.muted, textAlign: 'center' }}>Henter pipeline-data...</div>;
  if (fejl)    return <div style={{ padding: 32, color: C.roed }}>Fejl: {fejl}</div>;
  if (!data)   return null;

  const trin    = data.trin || [];
  const maxVal  = Math.max(...trin.map(t => t.vaerdi), 1);
  const konvs   = data.konverteringer || [];

  return (
    <div style={{ background: C.bg, minHeight: '100vh', padding: '20px 16px', color: C.text, fontFamily: 'system-ui, sans-serif' }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 18, fontWeight: 700 }}>Klient-Pipeline Funnel</h2>
      <div style={{ color: C.muted, fontSize: 13, marginBottom: 24 }}>Beregner-sessioner til afsluttede klienter</div>

      {/* Funnel */}
      <div style={{ maxWidth: 500, margin: '0 auto' }}>
        {trin.map((t, i) => {
          const pct = (t.vaerdi / maxVal) * 100;
          const leftPct  = (100 - pct) / 2;
          // Konverteringsrate under dette trin (ikke for siste)
          const konv = i < konvs.length ? konvs[i] : null;

          return (
            <div key={t.label}>
              {/* Funnel-segment */}
              <div style={{
                marginLeft:  `${leftPct}%`,
                width:        `${pct}%`,
                background:   t.farve,
                borderRadius: i === 0 ? '8px 8px 0 0' : i === trin.length - 1 ? '0 0 8px 8px' : 0,
                padding:      '14px 12px',
                textAlign:    'center',
                minHeight:    52,
                display:      'flex',
                flexDirection:'column',
                alignItems:   'center',
                justifyContent: 'center',
                transition:   'all 0.3s ease',
              }}>
                <div style={{ fontSize: 22, fontWeight: 800, color: '#fff' }}>
                  {t.vaerdi.toLocaleString('da-DK')}
                </div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.85)', marginTop: 2 }}>
                  {t.label}
                </div>
              </div>

              {/* Konverteringsrate pil */}
              {konv && (
                <div style={{
                  display:        'flex',
                  alignItems:     'center',
                  justifyContent: 'center',
                  padding:        '6px 0',
                  gap:            8,
                }}>
                  <div style={{ color: C.muted, fontSize: 18 }}>↓</div>
                  <div style={{ fontSize: 12, color: C.muted }}>
                    {konv.fra}:
                    <strong style={{ color: konv.pct !== null ? C.text : C.muted, marginLeft: 4 }}>
                      {konv.pct !== null ? `${konv.pct}%` : 'Ikke beregnet'}
                    </strong>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* Forklaring */}
      <div style={{
        marginTop: 24,
        background: C.card,
        border: `1px solid ${C.border}`,
        borderRadius: 10,
        padding: '12px 16px',
        fontSize: 12,
        color: C.muted,
        maxWidth: 500,
        margin: '24px auto 0',
      }}>
        <div style={{ fontWeight: 600, color: C.text, marginBottom: 6 }}>Datakilde</div>
        <div>Beregner-sessioner: seneste 30 dage</div>
        <div>Nye klienter: seneste 90 dage</div>
        <div>Aktive klienter: alle ikke-slettede</div>
        <div>Afsluttede: slettede seneste 90 dage</div>
      </div>
    </div>
  );
}